import { PDFDocumentProxy } from 'pdfjs-dist';
import { PDFError } from './types';

export async function renderPDFPage(
  canvas: HTMLCanvasElement,
  pdf: PDFDocumentProxy,
  pageNumber: number = 1,
  scale: number = 1
): Promise<void> {
  if (!canvas) {
    throw new PDFError('Canvas element is required', 'INVALID_CANVAS');
  }

  try {
    const page = await pdf.getPage(pageNumber);
    const viewport = page.getViewport({ scale });

    // Set canvas dimensions
    canvas.width = viewport.width;
    canvas.height = viewport.height;

    const context = canvas.getContext('2d', {
      alpha: false,
      desynchronized: true,
      willReadFrequently: false
    });

    if (!context) {
      throw new PDFError('Canvas context not available', 'CONTEXT_ERROR');
    }

    // Clear canvas
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, viewport.width, viewport.height);

    // Render PDF page
    await page.render({
      canvasContext: context,
      viewport,
      enableWebGL: false,
      renderInteractiveForms: false
    }).promise;

  } catch (error) {
    console.error('PDF rendering error:', error);
    throw new PDFError(
      'Failed to render PDF page',
      'RENDER_ERROR',
      error
    );
  }
}